import { ColorType, VariantClassesProps } from '../../utils'
import { InputSize } from '../Input/Input.types'
import { IconVariant } from './Icon.types'

/** Size styles controller */
export const getIconSizeClasses = (inputSize: InputSize): string => {
    const sizeClasses: VariantClassesProps = {
        sm: 'h-5 w-5 top-xl',
        base: 'w-6 h-6 !top-xl',
        md: 'w-[30px] h-[30px] top-xxl',
        lg: 'w-7 h-7 top-xxxl',
    }
    return sizeClasses[inputSize] || sizeClasses.md // Default size: md
}

// Variant styles
/** Styles for contained icon variant */
const getContainedClasses = (color: ColorType): string => {
    const colorClasses: VariantClassesProps = {
        primary:
            'stroke-color-text-light disabled:stroke-disabled dark:stroke-color-stroke-dark fill-color-text-light dark:fill-color-stroke-dark',
        error: 'stroke-color-dark disabled:stroke-disabled fill-color-dark',
        success: 'stroke-color-dark disabled:stroke-disabled fill-color-dark',
        warning: 'stroke-color-dark disabled:stroke-disabled fill-color-dark',
        gradient: 'stroke-none dark:stroke-none fill-color-dark',
    }

    return colorClasses[color] || colorClasses.primary // Default color: primary
}

// Variant styles
/** Styles for outlined icon variant */
const getOutlinedClasses = (color: ColorType): string => {
    const colorClasses: VariantClassesProps = {
        primary:
            'stroke-color-dark disabled:stroke-disabled dark:stroke-color-dark fill-none',
        error: 'stroke-error disabled:stroke-disabled fill-color-error',
        success: 'stroke-success disabled:stroke-disabled fill-color-success',
        warning: 'stroke-warning disabled:stroke-disabled fill-color-warning',
        gradient: 'stroke-color-active disabled:stroke-disabled fill-none',
    }

    return colorClasses[color] || colorClasses.primary // Default color: primary
}

// Variant styles
/** Styles for link icon variant */
const getLinkClasses = (color: ColorType): string => {
    const colorClasses: VariantClassesProps = {
        error: 'stroke-error hover:text-error active:text-error disabled:text-disabled fill-none',
        success:
            'stroke-success hover:text-success active:text-success disabled:text-disabled fill-none',
        warning:
            'stroke-warning hover:text-warning active:text-warning disabled:text-disabled fill-none',
        primary:
            'fill-color-text-light hover:text-opacity-80 active:text-color-base disabled:text-color-disabled',
    }

    return colorClasses[color] || colorClasses.primary // Default color: primary
}

// Variant styles
/** Styles for primary variant variant */
export const getPrimaryClasses = (color: ColorType): string => {
    const colorClasses: VariantClassesProps = {
        error: 'fill-error stroke-none disabled:stroke-error',
        success: 'fill-success stroke-none disabled:stroke-success',
        warning: 'fill-warning stroke-none disabled:stroke-warning',
        primary:
            '!stroke-color-dark disabled:!stroke-disabled dark:!stroke-color-stroke-dark !fill-color-text-light dark:!fill-color-stroke-dark',
        gradient: 'stroke-color-active fill-none disabled:stroke-disabled',
    }

    return colorClasses[color] || colorClasses.primary // Default color: primary
}

/** Variant styles controller */
export const getVariantClasses = (
    variant: IconVariant,
    color: ColorType
): string => {
    const variantClasses: VariantClassesProps = {
        contained: getContainedClasses(color),
        outlined: getOutlinedClasses(color),
        text: getLinkClasses(color),
        link: getLinkClasses(color),
    }

    return variantClasses[variant] || variantClasses.contained // Default variant: contained
}
